import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AccessGroupStore } from '@features/frame-of-reference/modules/dataset/store/access-group.store';
import { MeResource, MeService } from '@shared/openapi/business';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { environment } from 'environments/environment';
import { catchError, map, of, switchMap, take, tap } from 'rxjs';

export const authGuard: CanActivateFn = () => {
  const oidcSecurityService = inject(OidcSecurityService);
  const meService = inject(MeService);
  const accessGroupStore = inject(AccessGroupStore);

  return oidcSecurityService.isAuthenticated$.pipe(
    take(1),
    switchMap(({ isAuthenticated }) => {
      // if not authenticated force login immediately
      if (!isAuthenticated && environment.enableAuthentication) {
        oidcSecurityService.authorize();
        return of(false);
      }

      // allow navigation if authenticated or auth disabled
      if (isAuthenticated || !environment.enableAuthentication) {
        if (accessGroupStore.loaded()) return of(true);

        return meService.getUserInfo().pipe(
          tap((meResource: MeResource) => {
            accessGroupStore.setUserGroups(meResource.groups);
          }),
          map(() => true),
          catchError((error) => {
            console.error('Error fetching user info:', error);

            // Let the interceptor handle token refresh, just force re-authentication on failure
            if (environment.enableAuthentication) {
              oidcSecurityService.authorize();
            }
            return of(false);
          }),
        );
      }

      return of(false);
    }),
  );
};
